import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  title: string
  text: string
}

export const PolicyCoalitionContent: RouteInfo[] = [
  {
    title: '',
    text:
      'The California Hispanic Chambers of Commerce is a strategic partner or member of several state and national policy coalitions that align with our policy priorities and enhance our advocacy efforts. As a member of these coalitions, CHCC participates in a variety of advocacy activities, including drafting and signing on to letters to policymakers and attending meetings with legislators. Joining coalitions amplifies CHCC’s advocacy efforts, helps build relationships with partner groups and demonstrates the strength and influence of group advocacy.',
  },
  {
    title: 'Affordable Clean Energy for All',
    text:
      'Affordable Clean Energy for All is a coalition of organizations representing renewable energy companies, electricity customers, seniors, small-business, faith-based organizations, other diverse community groups and the state’s three investor-owned utilities that have come together to advocate for much needed reform to California’s rooftop solar program to reflect today’s reduced cost of energy and to ensure everyone who uses the grid pays their fair share.',
  },
  {
    title: 'Alliance for Quality Broadband',
    text:
      'Alliance for Quality Broadband advocates for solutions to address the digital divide comprehensively, to get more Americans connected by encouraging investment in broadband deployment to reach every unserved area and through effective adoption programs that address barriers preventing people from subscribing to internet service.',
  },
  {
    title: 'Biz-Fed Los Angeles County Business Federation',
    text:
      'With more than 180 business organizations representing 400,000 employers with 3.5 million employees throughout LA County, BizFed is a massive, diverse grassroots alliance that advocates for policies and projects that strengthen our regional economy.',
  },
  {
    title: 'California Alliance for Jobs',
    text:
      'The California Alliance for Jobs (CAJ) is a unique labor-management partnership that advocates for responsible investments in public infrastructure projects. CAJ keeps California’s people and economy moving as the state’s population grows by focusing on improving water systems, expanding transportation networks and increasing the access and quality of our public infrastructure.',
  },
  {
    title: 'California Association for Micro Enterprise Opportunity (CAMEO)',
    text:
      'CAMEO is California’s statewide micro-business network made up of over 300 organizations, agencies, and individuals dedicated to furthering and advocating for Micro-Business development in California with small and micro-business financing such as loans and credit, technical assistance and business management training.',
  },
  {
    title: 'California Business Roundtable',
    text:
      'The California Business Roundtable is a non-partisan organization comprised of the senior executive leadership of the major employers throughout the state – with a combined workforce of more than half a million employees. For more than thirty-five years the Roundtable has identified the issues critical to a healthy business climate and provided the leadership needed to strengthen California’s economy and create jobs.',
  },
  {
    title: 'California Carbon Capture Coalition',
    text:
      'The California Carbon Capture Coalition is the state’s leading business and labor organization working to make carbon capture, utilization and sequestration (CCUS) a key element of California’s climate solutions. We support California’s efforts to reduce greenhouse gas emissions in line with the Paris Agreement, and in cost-effective ways that drive technology and create and maintain high quality jobs and robust economic growth in the state.',
  },
  {
    title: 'Californians for Affordable and Reliable Energy (CARE) ',
    text:
      'CARE is a broad-based coalition of small businesses, community groups, local business organizations, and statewide associations that are calling on policymakers to prioritize affordability and working Californians when making energy policy decisions.',
  },
  {
    title: 'Californians Against Retail and Residential Theft (CARRT)',
    text:
      "Californians Against Retail and Residential Theft (CARRT) is a broad-based coalition calling for needed changes in California's criminal justice system.",
  },
  {
    title: 'Coalition for Enhanced Marine Resources',
    text:
      'The Coalition for Enhanced Marine Resources (CEMR) encourages the development and use of artificial reefs in California by educating the public and engaging in advocacy regarding legislation and public policy proposals to facilitate the establishment of programs that will promote, enhance and augment the quality, use and enjoyment of open coastal marine resources.',
  },
  {
    title: 'Energy Ideas',
    text:
      'Energy IDEAS is a coalition of consumers, small businesses, energy providers, farmers, and families supporting energy policies that ensure an equitable future where all Californians can thrive.',
  },
  {
    title: 'Goods Movement Alliance',
    text:
      "The Goods Movement Alliance is a coalition of California industry leaders in the goods movement economy committed to creating and supporting common sense solutions to the goods movement crisis. The intricate and complex 'system of systems' is broken, creating a crisis of crises at every step of the supply chain. From statewide business associations to industry sector leaders, to regional and local advocacy groups, the Alliance is committed to driving solutions that will address the short- and long-term problems in the goods movement sector.",
  },
  {
    title: 'Home Building Alliance',
    text:
      'The Home Building Alliance (HBA) is a broad coalition of groups who support policies that would increase housing production for Californians, include incentivizing, streamlining, and reducing the overall cost of construction to build more housing units at all income levels.',
  },
  {
    title: 'New California Coalition (NCC)',
    text:
      'NCC is the non-partisan political home and voice for over 6.5 million “Common Sense” voters across California.  NCC wants results and is mobilizing to achieve them. The NCC is organizing everyday voters, business leaders, and community organizations from across the state into a movement to demand change and action.',
  },
  {
    title: 'Taxpayer Protection and Government Accountability Act',
    text:
      'California has the largest tax burden of any state, and massive increases in taxes and fees are adding to the state’s sky-high cost of living. The Taxpayer Protection and Government Accountability Act would give voters the right to vote on all state and local taxes.',
  },
]

@Component({
    selector: 'app-policy-coalition',
    templateUrl: './policy-coalition.component.html',
    styleUrls: ['./policy-coalition.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PolicyCoalitionComponent implements OnInit {
  mainTitle = 'Policy Coalitions'
  lists: any = []

  constructor() {}

  ngOnInit(): void {
    this.lists = PolicyCoalitionContent.filter((list) => list)
  }
}
